<!-- TODO: 逻辑处理完，需要删除 template 元素 -->
<template>
  <div class="auth-root">
    <div class="div-box">
      <img src="../assets/images/logo-img.jpg" class="logo-img">
      <p>用户：{{ userInfo.nickname }}</p>
      <el-button v-if="isLoginAuth" type="primary" @click="getAuthTokenFromServer">确认授权登录</el-button>
      <p>{{ tipText }}</p>
    </div>
  </div>
  <PaymentDialog ref="paymentDialog" />
</template>

<script setup>
import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { getUserToken, getUserInfo, getCacheAuthToken, saveAuthHandel, removeAuthHandel, saveCacheAuthToken, saveCacheToken, setWxPayInfo, saveAlipayFormHtml } from '@/utils/common';
import { checkAuthTokenInfo, getAuthToken } from '@/api/auth';
import PaymentDialog from './PayMentDialog.vue';
import { getAliPayInfo, getWxPayInfo } from '@/api/pay';
import { useRouter } from 'vue-router'
import { createOrder } from '@/api/order';
import JSEncrypt from 'jsencrypt';

const paymentDialog = ref(null)

const route = useRoute();
const router = useRouter();

const appId = route.query.appId;
const type = route.query.type;
const code = route.query.code;
const callbackUrl = route.query.callbackUrl;
const key = route.query.key;
let authTokenParam = null;

const isLoginAuth = ref(false)
const tipText = ref('')

const paramError = (text = '参数错误') => {
  ElMessage({ message: text, type: 'warning'})
  setTimeout(()=>{
    window.location.href="/"
  }, 3000)
}

const token = getUserToken();
const userInfo = getUserInfo();
console.log(userInfo)
const authToken = getCacheAuthToken();

// const payHandle = () => {
//   if(!appId || !code || code.length != 32 || !callbackUrl || (!callbackUrl.startsWith('http') && !callbackUrl.startsWith('https'))){
//       paramError();
//       return;
//     }

//     const authParams = '?appId=' + appId + '&code=' + code + '&type=' + type + '&callbackUrl=' + callbackUrl

//     if(token){
//       isLoginAuth.value = true;
//     }else{
//       //保存参数到缓存
//       saveAuthHandel(authParams)
//       tipText.value = '跳转到登录界面登录授权中.......';
//       setTimeout(()=>{
//         window.location.href='/signin';
//       }, 3000)
//     }
// }

//处理登录后的支付展示
const afterLoginPayHandle = () => {
  //$2$20250330111112384652bef1a5867
  //从token中获取appId
  buyVip(authTokenParam.substring(3,23))
}

// const publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmQ2ATR9OiKSlcSx93/zSaI9mVEG9XVSsqQi8X8L+MgOggnpij1K1GonCkBjheA+SQqwxzCvZ7+YuqBn7Zl01s2tDghBmeN3LaxSr4nbNOTqg56kkXcxc0dJXLsC6EIbw8Maham2Vs7QZ0U/0haLZiclf5hMJetCZyha6XBJHvqAASXhrLgRz0FlJlJM/tjS4SSDPcbg6v6QxZkZPmaSOK8Tt/3ucmSpaeNQwb+JPe3LJg2CwvaETU20nEGvWhzs0/tImqiShvC9YeBtPJYj6hxa632kBIMq8nW/+aam0bQI2yvh+4BQni2hHIcsqIMKNB36QysRp0hHvgu/OBmcoHQIDAQAB";
const privateKey = "MIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQCZDYBNH06IpKVxLH3f/NJoj2ZUQb1dVKypCLxfwv4yA6CCemKPUrUaicKQGOF4D5JCrDHMK9nv5i6oGftmXTWza0OCEGZ43ctrFKvids05OqDnqSRdzFzR0lcuwLoQhvDwxqFqbZWztBnRT/SFotmJyV/mEwl60JnKFrpcEke+oABJeGsuBHPQWUmUkz+2NLhJIM9xuDq/pDFmRk+ZpI4rxO3/e5yZKlp41DBv4k97csmDYLC9oRNTbScQa9aHOzT+0iaqJKG8L1h4G08liPqHFrrfaQEgyrydb/5pqbRtAjbK+H7gFCeLaEchyyogwo0HfpDKxGnSEe+C784GZygdAgMBAAECggEBAJi2NvE8rpB6r7THruUCDzNS+chSO87XANw8IjDuj9F5evsVgCf/X0KWd/JtUPMJnmc2Bw3wJylOI/mIyyYtFLrr6NTq5kPtEd3LJ2H0JfrXO9tKEkYg9fBJjsHQfRamfdvQZRibNQa0ShpmS9XXUnU/35biIdBQOVLB8LqTZtCUrA/WWTNkmlzrtn6qZCi46nmwBzUz6GH2E2di3/a7ZN8tr7Jl7/INEFbjtWMVxANH++WXWd1DH2sC6YJJN4al1vdG26A5DXNt39KAj4iWIDtI80pFeEx1H+pZzmZmRiBW/yitC+bGYANPER/yoeYS2W3v3ut57pQxnD2ZwWUG+kUCgYEAxzr9uSDjpHxsuaa3IsjRsBhakuHm7GcXMa/eW+FWSpcldLOYDzOCVkwdxaUXNQ0T4c15E8Fe1bUdmB/cUeGwNKHvULFqfON8VimaKEHFWx6aqw7t3VvFEcfTibrShqMeWAV7sUpdNsC8Ccrdxr0iXQO7oD3sZupCtJ9QmI7nKlMCgYEAxKoLZflLxegQZM8Ox80OpTIZe9FqWHFmnZtgXRJe62kcRRs+XX2Ih/Nl5+nejVlqCdao6wTYHdQrvCD1NG4+UFANvl9HjURcqiYx7/yE/ByU400L7zZTa4BDZHx1+DPszlWBK3sTk3kh+ZeKOmCwxuhxKmA/5rG0ZUFoVWPMdc8CgYEAwetrdzzKFxp9AZ+CdjsdzteFoZ58lPIrI1PZjXkh8ux3qsX8Zh9u5+yitfRhSGP4TDshdNctJbpqmd25J4ITbseIFvT5f6I1LfDEeha6sFxzk7iuUl22zf3AqzjLHf271VVQ9lo5rMegv69UetMxlXPCttBPQEUYtJK1cij2XL0CgYEAuUtN+gJs9ka0S4cbcf0uc09E23hwLmyKNq0Smh6Y+EzMqgAFPqjsXsthlKSxX5SDaEmsVeL2jQQ/QL38yi2k4J7MlDXJgLyMYnQiUO8njTKQxajuObCB4KO025S4weaKk83UKleIFkbnT/cL8fzwEjknhrmw+3crdMuvteSV29kCgYBgxh2d1V4hSkyKpcdtBSy/Ns45EqcUa13DfB5tR/fWBLCAh7ncY/NLEO+oFtOJkN7DFOmUG1gO3QJ3GYQmshfO2jnwm2BEhopb3oW053RLQMhdmtyAUsDopCb80Uvo9U1CpB0ODSeKnm7jJW9OpAJrNQ9oE/9Ey4oWaNbnMZ73kQ==";
// 加密函数
// const encryptText = (plainText) => {
//   const encryptor = new JSEncrypt();
//   encryptor.setPublicKey(publicKey);
//   return encryptor.encrypt(plainText.value);
// };

// 解密函数
const decryptText = (encryptedText) => {
  const decryptor = new JSEncrypt();
  decryptor.setPrivateKey(privateKey);
  return decryptor.decrypt(encryptedText);
};

const createOrderInfo = (platformCode, callback) => {
  //创建购买订单
  //20250330111183747383：智码平台编号，all: 联合会员编号
  createOrder({platformCode: platformCode}).then(response => {
    const orderRes = response.data;
    if(orderRes.code === 200){
      const orderInfo = orderRes.data;
      if(callback){
        callback(orderInfo)
      }
    }else{
      ElMessage({
        message: orderRes.msg,
        type: 'warning'
      })
    }

  })
}

const buyVip = (platformCode) => {

  if(platformCode){
    paymentDialog.value.openDialog((paymentType) => {
      if (paymentType === 'wechat') {

        console.log('用户选择了微信支付');
        // 在这里处理微信支付逻辑
        createOrderInfo(platformCode, (orderInfo) => {
          // TODO 目前默认使用微信，后续添加弹窗选择，先跑通流程
          //使用订单信息向后端申请微信支付信息用于扫码支付
          getWxPayInfo({orderNo: orderInfo.orderNo}).then( wxResponse => {
            const wxRes = wxResponse.data;
            if(wxRes.code === 200){

              //缓存微信支付信息给支付页面进行扫码使用
              const wxPayInfo = wxRes.data;
              setWxPayInfo(wxPayInfo)
              router.push('/wxPay')

            }
          })
        });

      } else if (paymentType === 'alipay') {

        console.log('用户选择了支付宝支付');
        // 在这里处理支付宝支付逻辑
        createOrderInfo(platformCode, (orderInfo) => {
          getAliPayInfo({orderNo: orderInfo.orderNo}).then(response => {
            const res = response.data;
            if(res.code === 200){
              const payFormHtml = res.data;
              saveAlipayFormHtml(payFormHtml)
              //跳转到支付宝Form Html内容的承载页
              window.location.href='/alipay'
            }else{
              ElMessage({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        });

      } else if (paymentType === 'cancel') {
        console.log('用户关闭了弹窗');
        // 在这里处理取消逻辑
      }
    });
    return;
  }
  //创建购买订单
  //20250330111183747383：智码平台编号，all: 联合会员编号
  createOrder({platformCode: platformCode}).then(response => {
    const orderRes = response.data;
    if(orderRes.code === 200){

      const orderInfo = orderRes.data;
      // TODO 目前默认使用微信，后续添加弹窗选择，先跑通流程
      //使用订单信息向后端申请微信支付信息用于扫码支付
      getWxPayInfo({orderNo: orderInfo.orderNo}).then( wxResponse => {
        const wxRes = wxResponse.data;
        if(wxRes.code === 200){

          //缓存微信支付信息给支付页面进行扫码使用
          const wxPayInfo = wxRes.data;
          setWxPayInfo(wxPayInfo)
          router.push('/pay')

        }else{
          ElMessage({
            message: wxRes.msg,
            type: 'warning'
          })
        }
      })

    }else{
      ElMessage({
        message: orderRes.msg,
        type: 'warning'
      })
    }


  })
}


const initPage = () => {
  if(!type || (type != 'login' && type != 'pay')){
    paramError();
    return;
  }

  if(type == 'login'){
    if(authToken){
      isLoginAuth.value = true;
    }else{
      if(!appId || !code || code.length != 32 || !callbackUrl || (!callbackUrl.startsWith('http') && !callbackUrl.startsWith('https'))){
        paramError();
        return;
      }

      const authParams = '?appId=' + appId + '&code=' + code + '&type=' + type + '&callbackUrl=' + callbackUrl

      if(token){
        isLoginAuth.value = true;
      }else{
        //保存参数到缓存
        saveAuthHandel(authParams)
        tipText.value = '跳转到登录界面登录授权中.......';
        setTimeout(()=>{
          window.location.href='/signin';
        }, 3000)
      }
    }
  }else if(type == 'pay'){
    console.log(key)
    if(key){
      authTokenParam = decryptText(key)
      if(!authTokenParam){
        paramError();
        return;
      }
      console.log(authTokenParam)
      checkAuthTokenInfo({token: authTokenParam}).then(response => {
        const res = response.data;
        if(res.code === 200){
          saveCacheToken(authTokenParam)
          saveCacheAuthToken(authTokenParam)
          afterLoginPayHandle()
        }else{
          paramError('参数无效');
        }
      })
    }else{
      paramError();
      return;
    }
  }
  
}

onMounted(() => {
  initPage();
})

const getAuthTokenFromServer = () => {
  removeAuthHandel()
  if(authToken){
    window.location.href = callbackUrl+'?token='+authToken;
  }else{
    getAuthToken({appId: appId, accessCode: code}).then(response => {
      const res = response.data;
      if(res.code == 200){
        const authTokenData = res.data;
        tipText.value = '授权成功，返回应用平台中...'
        isLoginAuth.value = false;
        ElMessage({ message: '授权成功', type: 'success'})
        setTimeout(() => {
          window.location.href = callbackUrl+'?token='+authTokenData;
        }, 3000);
      }else{
        tipText.value = res.msg;
      }
    });
  }
}

</script>



<style>
.auth-root{
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-box{
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.logo-img{
  width: 100px;
  height: 100px;
  border-radius: 50px;
  margin-bottom: 10px;
}
.el-button{
  margin-top: 30px;
}

</style>